<article class="registration-card">
  <div
    class="registration-card__hero"
    [class.registration-card__hero--empty]="!backgroundImgUrl"
    [class.registration-card__hero--with-logo]="orgLogoUrl"
    [style.background-image]="backgroundImage">
    @if (orgLogoUrl) {
      <span
        class="registration-card__avatar-badge registration-card__avatar-badge--org"
        aria-hidden="true">
        <img
          class="registration-card__logo"
          [src]="orgLogoUrl"
          [alt]="orgName + ' logo'">
      </span>
    }

    <div class="registration-card__hero-content">
      <p class="registration-card__org-name">{{ orgName }}</p>
      <h3 class="registration-card__hero-title">{{ registrationName }}</h3>
      @if (sport || type) {
        <p class="registration-card__hero-meta">
          @if (sport) {
            <span>{{ sport }}</span>
          }
          @if (sport && type) {
            <span aria-hidden="true">&bull;</span>
          }
          @if (type) {
            <span>{{ type }}</span>
          }
        </p>
      }
    </div>

    @if (linkUrl) {
      <button
        type="button"
        class="registration-card__share-action"
        (click)="copyLinkToClipboard()"
        [attr.aria-label]="shareLabel">
        <se-fe-icon seFeDataName="share_android_fill" seFeDataColor="white" [seFeDataMargin]="false"></se-fe-icon>
      </button>
    }
  </div>

  <div
    class="registration-card__body"
    [class.registration-card__body--with-avatar]="avatarUrl">
    @if (avatarUrl) {
      <div
        class="registration-card__profile-avatar"
        aria-hidden="true">
        <span
          class="registration-card__avatar-badge registration-card__avatar-badge--person">
          <img
            class="registration-card__avatar-image"
            [src]="avatarUrl"
            [alt]="registrationName + ' avatar'">
        </span>
      </div>
    }

    @if (infoHeaderText || infoText || orderUrl) {
      <section class="registration-card__status">
        @if (infoHeaderText) {
          <h4 class="registration-card__status-title">{{ infoHeaderText }}</h4>
        }
        @if (orderUrl) {
          <a
            class="registration-card__order-link"
            [href]="orderUrl"
            target="_blank"
            rel="noopener noreferrer">
            {{ orderDetailsText }}
          </a>
        }
        @if (infoText) {
          <p class="registration-card__status-text">{{ infoText }}</p>
        }
      </section>
    }

    @if (linkUrl && buttonText && !avatarUrl) {
      <a
        class="registration-card__primary-action"
        [href]="linkUrl"
        target="_blank"
        rel="noopener noreferrer">
        {{ buttonText }}
      </a>
    }

    @if (linkUrl && linkText) {
      <a
        class="registration-card__secondary-link"
        [href]="linkUrl">
        {{ linkText }}
      </a>
    }
  </div>
</article>
